"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AlpineComponent {
}
exports.default = AlpineComponent;
